export interface EventsRequest {
  eventName?: string;
  source?: string;
  keywordSearch?: string;
  publishStatus?: PublishStatus | "";
  startDate?: string;
  endDate?: string;
  currentPage?: number;
  pageSize?: number;
}

export interface EventsResponse {
  id: string;
  eventSource: string;
  eventName: string;
  addedAtUtc: string;
  lastUpdateDateUtc: string;
  consumers: Consumer[];
  event: Event;
  publishStatus: PublishStatus;
  consumptionStatus: string;
}

export interface ReprocessEvent {
  eventId: string;
  type: number;
}

export interface ReprocessConsumer {
  eventId: string;
  type: number;
  queueName: string;
}

export interface Consumer {
  handlerName: string;
  queueName: string;
  status: string;
  dateConsumedUtc: string;
  messageError: string;
}

interface Event {
  _t: string;
  _id: string;
  CreationDate: string;
  Source: string;
  TraceKey: string;
  EventSuffix: string;
  Contents: string;
  OriginalFile: OriginalFile;
}

interface OriginalFile {
  _id: string;
  FileName: string;
  Metadata: Metadata;
}

interface Metadata {
  header: string;
  trailer: string;
  contentHeader: string;
  contentTrailer: string;
  source: number;
  acquirerId: number;
}

export enum PublishStatus {
  "Não definido",
  "Publicação Pendente",
  "Sem Consumidor",
  "Publicado",
  "Erro",
}
